import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const searchTrailers = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/trailers/search`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error();
    }
};

export const addTrailerData = async (data) => {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/trailers`,
        data,
    );
    return response.data;
};

export const updateTrailerData = async (data) => {
    const response = await gatewayInstance.put(
        `${SERVICE_ENDPOINT.TRANSPORT}/trailers`,
        data,
    );
    return response.data;
};

export const getTrailerDataById = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/trailers/${id}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
};
